export class UpdateUserFailure {
    static readonly type = '[User] UpdateUserFailure ';

    constructor(public payload: string) {}
}
